angular.module("ainapp")
    .controller("paySheetSummaryReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Paysheet Summary Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {


                $('#filterModal').modal('show');
                var startdate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

                $scope.filter = {
                    VoucherNo: "",
                    EmployeeIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                    BranchId: "",
                }

                $scope.load = false;
                $scope.isFilter = false;

                $scope.Fields = {
                    EmployeeCode: { type: "string", editable: false },
                    EmployeeName: { type: "string", editable: false },
                    RefNo: { type: "string", editable: false },
                    Month: { type: "string", editable: false },
                    Year: { type: "number", editable: false },
                    Date: { type: "date", editable: false },
                    DaysAttended: { type: "number", editable: false },
                    NetSalary: { type: "number", editable: false },
                    OvertimeSalary: { type: "number", editable: false },
                    LateHourDeduction: { type: "number", editable: false },
                    TotalDeductions: { type: "number", editable: false },
                    TotalSalary: { type: "number", editable: false }
                }
    
                $scope.Columns = [
                    {
                        field: "EmployeeCode",
                        title: "Employee Code",
                        width: '100px',
                        },
                    {
                        field: "EmployeeName",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                        width: '100px',
                        },
                    {
                        field: "RefNo",
                        title: "RefNo", 
                        width: '100px',
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        headerTemplate: "{{LanguageData.Date}}",
                        width: '100px',
                        },
                        {
                        field: "Year",
                        title: "Year",
                        width: '100px',
                        },
                         {
                        field: "Month",
                        title: "Month",
                        width: '100px',
                        },
                        {
                        field: "DaysAttended",
                        title: "Days Attended",
                        width: '100px',
                        },
                ]

                $scope.Aggregates = [{
                    field: "NetSalary",
                    aggregate: "sum"
                },
                {
                    field: "OvertimeSalary",
                    aggregate: "sum"
                },
                {
                    field: "LateHourDeduction",
                    aggregate: "sum"
                },
                {
                    field: "TotalDeductions",
                    aggregate: "sum"
                },
                {
                    field: "TotalSalary",
                    aggregate: "sum"
                }];

                $scope.Components = [];
                    MainService.PayrollComponentsInSalary().then(function (response) {
                        $scope.Components = response.data;

                        angular.forEach($scope.Components, function (e) {
                            var field = e.Name.replace(/ /g, '');
                            field = field.replace('&', '');
                            field = field.replace('/', '');
                            field = field.replace('.', '');

                            var clm = {
                                title: e.Name,
                                field: "CC" + field, 
                                width: '100px', 
                                //aggregates: ["sum"],
                                template: "<div style='text-align: right'>#=kendo.toString(" + "CC" + field +", 'n')#</div>",
                               // footerTemplate: "#=kendo.toString(sum, 'n')#",
                                headerTemplate: kendo.template("<div class='headerright'>"+e.Name+"</div>")
                            }
                            $scope.Columns.push(clm);

                            // var agg = {
                            //     field: "CC" + field, 
                            //     aggregate: "sum"
                            //         }
                            // $scope.Aggregates.push(agg);

                            var newFieldName = "CC" + field;
                            $scope.Fields[newFieldName] = {
                                type: "number",
                                editable: false
                            };

                        })

                        var t1 = {
                            field: "NetSalary",
                            title: "Net Salary",
                            width: '100px',
                            aggregates: ["sum"],
                            template: "<div style='text-align: right'>#=kendo.toString(NetSalary, 'n')#</div>",
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Net Salary</div>")
                        };
                        $scope.Columns.push(t1);
                        var t2 =
                        {
                            field: "OvertimeSalary",
                            title: "Overtime Salary",
                            width: '100px',
                             aggregates: ["sum"],
                            template: "<div style='text-align: right'>#=kendo.toString(OvertimeSalary, 'n')#</div>",
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Overtime Salary</div>")
                        };
                        $scope.Columns.push(t2);
                        var t3 =
                        {
                            field: "LateHourDeduction",
                            title: "Late Hour Deduction",
                            width: '100px',
                             aggregates: ["sum"],
                            template: "<div style='text-align: right'>#=kendo.toString(LateHourDeduction, 'n')#</div>",
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Late Hour Deduction</div>")
                        };
                        $scope.Columns.push(t3);
                        var t4 =
                        {
                            field: "TotalDeductions",
                            title: "Total Deductions",
                            width: '100px',
                             aggregates: ["sum"],
                            template: "<div style='text-align: right'>#=kendo.toString(TotalDeductions, 'n')#</div>",
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Total Deductions</div>")
                        };
                        $scope.Columns.push(t4);
                        var t5 =
                        {
                            field: "TotalSalary",
                            title: "Total Salary",
                            width: '100px',
                             aggregates: ["sum"],
                            template: "<div style='text-align: right'>#=kendo.toString(TotalSalary, 'n')#</div>",
                            footerTemplate: "#=kendo.toString(sum, 'n')#",
                            headerTemplate: kendo.template("<div class='headerright'>Total Salary</div>")
                        };
                        $scope.Columns.push(t5);

                        $scope.loadKendoSummary();
                    });

                

            }
            $scope.Init();


            $scope.employeeSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.EmployeesInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    //toastr.error("NetworkError");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 20
            };

            $scope.selectEmployeeOptions = {
                placeholder: "Select Employees...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.employeeSelectDataSource
            };


                $scope.loadKendoSummary = function () {

                    $scope.KendoSource = new kendo.data.DataSource({
                        batch: true,
                        transport: {
                            read: function (o) {

                                o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                                o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);
                                o.data.EmployeeIds = $scope.filter.EmployeeIds;

                                MainService.PaysheetSummaryReport(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error($scope.LanguageData.NetworkError);
                                })
                            },

                        },
                           change: function (data) {
                            if (data.items.length > 0) {
                                console.log(data);
                                var arr = [];
                                angular.forEach($scope.Components, function (e) {
                                    var field = e.Name.replace(/ /g, '');
                                    field = field.replace('&', '');
                                    field = field.replace('/', '');
                                    field = field.replace('.', '');
                                    arr.push('CC' + field);
                                })
                                angular.forEach(data.items, function (e) {
                                    angular.forEach(arr, function (ar) {

                                        angular.forEach(e.SalaryReportDetails, function (a) {

                                            var afield = a.ComponentName.replace(/ /g, '');
                                            afield = afield.replace('&', '');
                                            afield = afield.replace('/', '');
                                            afield = afield.replace('.', '');
                                            afield = "CC" + afield;

                                            if (afield == ar) {
                                                e[ar] = a.Amount;
                                            }else{
                                                e[ar] = 0;
                                            }
                                        })


                                    })

                                  
                                })
                            }
                        },
                        schema: {
                            data: "Data",
                            total: "Total",
                            model: {
                                id: "Id",
                                fields: $scope.Fields
                            }
                        },

                        aggregate: $scope.Aggregates,

                        serverPaging: true,
                        serverSorting: true,
                        serverFiltering: true,
                        pageSize: 20,
                    });

                    $scope.KendoGridOptions = {

                        editable: false,
                        pageable: true,
                        toolbar: ["excel", "pdf"],
                        height: 600,
                        resizable: true,
                        dataSource: $scope.KendoSource,
                        pageSize: 20,
                        pageable: {
                            input: false,
                            refresh: true,
                            pageSizes: true,
                            info: true,
                        },
                        sortable: true,
                        scrollable: true,
                        filterable: true,
                        groupable: true,
                        columnMenu: {
                            filterable: false,
                            filterable: true,
                        },
                        columns: $scope.Columns,
                    };

                }


            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }



            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

                }])
